import * as angular from 'angular';

import { Interpolation } from '../../common';
import { KeyValuePair, ComponentDefinition } from '../../models';

class InterpolatePickerController implements angular.IComponentController {
    items: KeyValuePair<string, string>[];
    static $inject = [];

    $onInit() {
        this.items = Interpolation;
    }
}

export const wtInterpolatePicker: ComponentDefinition = {
    componentId: 'wtInterpolatePicker',
    controller: InterpolatePickerController,
    template: require('./interpolatePicker.component.html'),
    controllerAs: 'vm',
    bindings: {
        model: '=',
        onChange: '&?'
    }
};
